import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Componente para la página de inicio
function HomePage() {
  const navidadEmojis = ["✨", "⭐", "🎁", "❄️", "🔔", "✨"];

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0a0a0a 0%, #1a0f00 25%, #2d1400 50%, #1a0f00 75%, #0a0a0a 100%)",
      position: "relative",
      overflow: "hidden",
      padding: "2rem 1rem"
    }}>
      {/* Efectos de fondo */}
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: `
          radial-gradient(circle at 20% 80%, rgba(255, 106, 0, 0.15) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(255, 106, 0, 0.15) 0%, transparent 50%)
        `,
        pointerEvents: "none",
        zIndex: 0
      }} />

      {/* Emojis flotantes de fondo */}
      {navidadEmojis.map((emoji, index) => (
        <div
          key={index}
          style={{
            position: "fixed",
            fontSize: "4rem",
            opacity: 0.15,
            pointerEvents: "none",
            zIndex: 0,
            animation: `float 8s ease-in-out infinite`,
            animationDelay: `${index * 0.5}s`,
            top: `${[10, 20, 50, 40, 15, 25][index]}%`,
            left: `${[10, 85, 5, 90, 50, 70][index]}%`,
            filter: "drop-shadow(0 0 10px rgba(255, 106, 0, 0.3))"
          }}
        >
          {emoji}
        </div>
      ))}

      {/* Nieve cayendo */}
      {[...Array(50)].map((_, i) => (
        <div
          key={`snow-${i}`}
          style={{
            position: "fixed",
            top: "-10px",
            left: `${Math.random() * 100}%`,
            width: "8px",
            height: "8px",
            background: "white",
            borderRadius: "50%",
            opacity: Math.random() * 0.6 + 0.3,
            animation: `snowfall ${Math.random() * 3 + 5}s linear infinite`,
            animationDelay: `${Math.random() * 5}s`,
            pointerEvents: "none",
            zIndex: 1
          }}
        />
      ))}

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          25% { transform: translateY(-20px) rotate(5deg); }
          50% { transform: translateY(-15px) rotate(-5deg); }
          75% { transform: translateY(-25px) rotate(3deg); }
        }
        
        @keyframes snowfall {
          to { transform: translateY(100vh); opacity: 0; }
        }
        
        @keyframes glow {
          0%, 100% { 
            text-shadow: 0 0 20px rgba(255, 106, 0, 0.8),
                         0 0 40px rgba(255, 106, 0, 0.6);
          }
          50% { 
            text-shadow: 0 0 30px rgba(255, 106, 0, 1),
                         0 0 60px rgba(255, 106, 0, 0.8);
          }
        }
        
        @keyframes logoGlow {
          0%, 100% { filter: drop-shadow(0 0 20px rgba(255, 106, 0, 0.6)); }
          50% { filter: drop-shadow(0 0 35px rgba(255, 106, 0, 0.9)); }
        }
      `}</style>

      <div style={{ position: "relative", zIndex: 2 }}>
        {/* Header con logo */}
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <img
            src="https://invercycle.com/wp-content/uploads/2023/04/LOGOINVERCYCLE.png"
            alt="Invercycle"
            style={{
              maxWidth: "250px",
              height: "auto",
              animation: "logoGlow 3s ease-in-out infinite",
              marginBottom: "1.5rem"
            }}
          />
        </div>

        {/* Título principal */}
        <h1 style={{
          fontSize: "clamp(2.5rem, 6vw, 5rem)",
          color: "#ff6a00",
          fontFamily: "Arial Black, sans-serif",
          textShadow: "0 0 20px rgba(255, 106, 0, 0.8), 3px 3px 8px rgba(0, 0, 0, 0.9)",
          textAlign: "center",
          marginBottom: "0.5rem",
          animation: "glow 3s ease-in-out infinite"
        }}>
          🏍️ Motos Invercycle 🏍️
        </h1>
        
        <p style={{
          fontSize: "clamp(1.2rem, 3vw, 1.8rem)",
          color: "#ffde59",
          textShadow: "0 0 15px rgba(255, 222, 89, 0.8)",
          fontWeight: "700",
          textAlign: "center",
          marginBottom: "2rem"
        }}>
          ✨ ¡Encuentra las motos premiadas y gana! ✨
        </p>

        {/* Mensaje de bienvenida */}
        <div style={{
          maxWidth: "600px",
          margin: "0 auto",
          background: "rgba(0, 0, 0, 0.8)",
          backdropFilter: "blur(10px)",
          border: "3px solid #ff6a00",
          borderRadius: "20px",
          padding: "2.5rem 2rem",
          boxShadow: "0 0 40px rgba(255, 106, 0, 0.6)"
        }}>
          <h2 style={{
            fontSize: "1.8rem",
            marginBottom: "1.5rem",
            color: "#ff6a00",
            textAlign: "center",
            textShadow: "0 0 10px rgba(255, 106, 0, 0.8)"
          }}>
            ✨ ¡Bienvenido al Juego Invercycle! ✨
          </h2>
          
          <p style={{ 
            color: "#ff9d00", 
            fontSize: "1.2rem", 
            lineHeight: "1.6",
            textAlign: "center",
            marginBottom: "1rem"
          }}>
            Para jugar, necesitas un <strong style={{ color: "#ffde59" }}>link personalizado</strong> con tu token único.
          </p>
          
          <p style={{ 
            color: "#ff9d00", 
            fontSize: "1rem", 
            textAlign: "center",
            opacity: 0.8
          }}>
            Si recibiste un link de Invercycle, úsalo para acceder al juego. 🎁
          </p>

          {/* Ejemplo visual */}
          <div style={{
            marginTop: "2rem",
            padding: "1.5rem",
            background: "rgba(255, 106, 0, 0.1)",
            borderRadius: "15px",
            border: "2px dashed #ff6a00"
          }}>
            <p style={{ 
              color: "#ffde59", 
              fontSize: "0.9rem", 
              marginBottom: "0.5rem",
              fontWeight: "bold",
              textAlign: "center"
            }}>
              Ejemplo de link:
            </p>
            <code style={{
              color: "#ff9d00",
              fontSize: "0.85rem",
              wordBreak: "break-all",
              display: "block",
              padding: "0.5rem",
              background: "rgba(0, 0, 0, 0.5)",
              borderRadius: "8px",
              textAlign: "center"
            }}>
              tu-sitio.com/motos/ABC123XYZ
            </code>
          </div>
        </div>

        {/* Footer decorativo */}
        <div style={{ 
          marginTop: "3rem",
          textAlign: "center",
          fontSize: "3rem"
        }}>
          ✨ 🎁 🏍️
        </div>
      </div>
    </div>
  );
}

// Componente 404 - Página no encontrada
function NotFound() {
  const navidadEmojis = ["🔔", "⭐", "🎁", "✨", "🔔", "✨"];

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0a0a0a 0%, #1a0f00 25%, #2d1400 50%, #1a0f00 75%, #0a0a0a 100%)",
      position: "relative",
      overflow: "hidden",
      padding: "2rem 1rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}>
      {navidadEmojis.map((emoji, index) => (
        <div
          key={index}
          style={{
            position: "fixed",
            fontSize: "4rem",
            opacity: 0.15,
            pointerEvents: "none",
            zIndex: 0,
            top: `${[10, 20, 50, 40, 15, 25][index]}%`,
            left: `${[10, 85, 5, 90, 50, 70][index]}%`
          }}
        >
          {emoji}
        </div>
      ))}

      <div style={{ position: "relative", zIndex: 2, textAlign: "center" }}>
        <img
          src="https://invercycle.com/wp-content/uploads/2023/04/LOGOINVERCYCLE.png"
          alt="Invercycle"
          style={{
            maxWidth: "200px",
            height: "auto",
            marginBottom: "2rem"
          }}
        />

        <h1 style={{
          fontSize: "clamp(3rem, 8vw, 6rem)",
          color: "#ff6a00",
          fontFamily: "Arial Black, sans-serif",
          textShadow: "0 0 20px rgba(255, 106, 0, 0.8)",
          marginBottom: "1rem"
        }}>
          404
        </h1>

        <div style={{
          background: "rgba(0, 0, 0, 0.8)",
          border: "3px solid #ff6a00",
          borderRadius: "20px",
          padding: "2rem",
          maxWidth: "500px"
        }}>
          <h2 style={{
            color: "#ff9d00",
            fontSize: "1.5rem",
            marginBottom: "1rem"
          }}>
            ¡Ups! Página no encontrada
          </h2>
          <p style={{ 
            color: "#ff9d00", 
            fontSize: "1.1rem"
          }}>
            Esta página no existe o el link está incorrecto ✨
          </p>
        </div>
      </div>
    </div>
  );
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Página de inicio */}
        <Route path="/" element={<HomePage />} />
        
        {/* Ruta del juego de motos con token */}
        <Route path="/motos/:token" element={<App />} />
        
        {/* Ruta 404 para páginas no encontradas */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);